import React, { useState, useCallback } from "react";
import { useLocation, Link } from "react-router-dom";

import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import ListIcon from "@mui/icons-material/List";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import PlaceIcon from "@mui/icons-material/Place";

import { Box, IconButton, Badge } from "@mui/material";
import { handleLogout } from "../utils/utils";
import { noSidebarRoutes, RouteKey } from "../routes/Routes";
import { useNotifications } from "../hoc/notifications/withNotifications";
import NotificationsIcon from "@mui/icons-material/Notifications";

export const Sidebar = React.memo(() => {
    const location = useLocation();
    const isAdmin = localStorage.getItem("userRole") === "admin";
    const notifications = useNotifications();
    const [mobileOpen, setMobileOpen] = useState(false);

    const closeMobileMenu = useCallback(() => setMobileOpen(false), []);

    if (noSidebarRoutes.some((route) => location.pathname.startsWith(route))) {
        return null; // Don't render sidebar on these routes
    }

    return (
        <>
            {/* Mobile hamburger button - fixed top-left */}
            <IconButton
                className="sidebar-mobile-toggle"
                onClick={() => setMobileOpen(!mobileOpen)}
                sx={{ display: { xs: "flex", md: "none" } }}>
                <MenuIcon />
            </IconButton>

            {/* Overlay backdrop for mobile */}
            {mobileOpen && <div className="sidebar-overlay" onClick={closeMobileMenu} />}

            <Box component="nav" className={`sidebar ${mobileOpen ? "sidebar-open" : ""}`}>
                <ul className="sidebar-list">
                    <li className="sidebar-item my-4 mb-5">
                        <IconButton color="inherit" className="sidebar-desktop-menu">
                            <MenuIcon />
                        </IconButton>
                        <IconButton color="inherit" className="sidebar-mobile-close" onClick={closeMobileMenu}>
                            <CloseIcon />
                        </IconButton>
                    </li>
                    <li className="sidebar-item">
                        <Link to={RouteKey.Home} className="sidebar-link" onClick={closeMobileMenu}>
                            <div className="sidebar-icon mb-1">
                                <ListIcon />
                            </div>
                            Full List
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={RouteKey.Onsite} className="sidebar-link" onClick={closeMobileMenu}>
                            <div className="sidebar-icon mb-1">
                                <PendingActionsIcon />
                            </div>
                            On Site
                        </Link>
                    </li>

                    <li className="sidebar-item">
                        <Link to={RouteKey.Workers} className="sidebar-link" onClick={closeMobileMenu}>
                            <div className="sidebar-icon mb-1">
                                <GroupsOutlinedIcon />
                            </div>
                            Workers
                        </Link>
                    </li>
                    {isAdmin ? (
                        <>
                            <li className="sidebar-item">
                                <Link to={RouteKey.Notifications} className="sidebar-link" onClick={closeMobileMenu}>
                                    <div className="sidebar-icon mb-1">
                                        <Badge
                                            badgeContent={notifications.unreadNotificationsCount}
                                            className="notification-badge">
                                            <NotificationsIcon />
                                        </Badge>
                                    </div>
                                    Notifications
                                </Link>
                            </li>
                            <li className="sidebar-item">
                                <Link to={RouteKey.Map} className="sidebar-link" onClick={closeMobileMenu}>
                                    <div className="sidebar-icon mb-1">
                                        <PlaceIcon />
                                    </div>
                                    Map
                                </Link>
                            </li>
                        </>
                    ) : null}

                    <hr className="sidebar-divider" />
                    <li className="sidebar-item">
                        <Link to={RouteKey.Login} className="sidebar-link" onClick={handleLogout}>
                            <div className="sidebar-icon mb-1">
                                <LogoutIcon />
                            </div>
                            Logout
                        </Link>
                    </li>
                </ul>
            </Box>
        </>
    );
});

Sidebar.displayName = "Sidebar";
